import api from './api';

export interface AuthHistoryItem {
  id: number;
  email: string;
  fullName: string;
  browser: string;
  dateTime: string;
  ip: string;
  status: 'success' | 'error';
  token_id: number | null;
  session_status: 'active' | 'terminated';
}

export interface AuthHistoryResponse {
  data: AuthHistoryItem[];
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export interface AuthHistoryParams {
  page?: number;
  per_page?: number;
  search?: string;
}

export const authHistoryService = {
  /**
   * Получить историю авторизаций (для админа - всех пользователей)
   */
  async getHistory(params: AuthHistoryParams = {}): Promise<AuthHistoryResponse> {
    const searchParam = params.search?.trim() || '';
    console.log('🔍 AuthHistory search request:', { 
      page: params.page || 1, 
      per_page: params.per_page || 25, 
      search: searchParam,
      searchLength: searchParam.length 
    });
    
    const { data } = await api.get<AuthHistoryResponse>('/auth-history', {
      params: {
        page: params.page || 1,
        per_page: params.per_page || 25,
        search: searchParam,
      },
    });
    
    console.log('✅ AuthHistory response:', { 
      total: data.total, 
      itemsCount: data.data.length,
      search: searchParam 
    });
    
    return data;
  },

  /**
   * Получить историю авторизаций текущего пользователя
   */
  async getMyHistory(params: AuthHistoryParams = {}): Promise<AuthHistoryResponse> {
    const { data } = await api.get<AuthHistoryResponse>('/auth-history/my', {
      params: {
        page: params.page || 1,
        per_page: params.per_page || 25,
      },
    });
    return data;
  },

  /**
   * Получить историю авторизаций конкретного пользователя (для админа)
   */
  async getUserHistory(userId: number, params: AuthHistoryParams = {}): Promise<AuthHistoryResponse> {
    const { data } = await api.get<AuthHistoryResponse>(`/auth-history/user/${userId}`, {
      params: {
        page: params.page || 1,
        per_page: params.per_page || 25,
      },
    });
    return data;
  },

  /**
   * Остановить сессию
   */
  async terminateSession(id: number): Promise<void> {
    await api.delete(`/auth-history/${id}/session`);
  },
};
